import _ from "lodash";
import { ColumnFlagParser } from '../../utils/helper';

const setProperties = (rowData, col, postfix) => {
  const fieldName = "I" + postfix;
  if (rowData.hasOwnProperty(fieldName)) {
    const iValue = rowData[fieldName];
    const cfp = new ColumnFlagParser(iValue);
    if (col.field === "L" + postfix) {
      setColProps(col, cfp.lNoCheck);
    } else if (col.field === "Por" + postfix) {
      setColProps(col, cfp.lNoOrder);
    } else if (col.field === "Sir" + postfix) {
      setColProps(col, cfp.lNoLength);
    } else if (col.field === "Tt" + postfix) {
      setColProps(col, cfp.lNoName);
    }
  }
}

const modifyPropValue = (rowData, control) => {
  const fieldName = "I" + control.field.substring(1);
  let iValue = rowData[fieldName]; //?? detailData.SpFrmSql[fieldName];
  if (!(typeof iValue === 'number')) {
    if (typeof rowData["IFrmSqlUz"] === 'number') {
      // U_FRM_SQL
      iValue = rowData.SpFrmSql[fieldName] ?? rowData.FrmSql[fieldName];
    } else {
      // SP_FRM_SQL
      iValue = rowData.SpFrmSql[fieldName];
    }
  }
  const cfp = new ColumnFlagParser(iValue);
  if (cfp.lVisible !== control.value) {
    cfp.lVisible = control.value;
    rowData[fieldName] = cfp.iColumnFlag;
  }
}

const setColProps = (col, bValue) => {
  if (bValue) {
    if (col.required)
      col.required = false;
    // col.editable = false;
    col.disabled = true;
  } else {
    col.disabled = false;
  }
}

const reducer = async (action, data, state, prevState) => {

  const primaryField = state.primaryField;

  // console.debug(`[action=${action},primaryField="${primaryField}"]`);
  switch (action) {
    case "GET_SCHEMA":
      return state;

    case "GET_LIST":
      return state;

    case "GET":
      {
        const { detailData } = state[primaryField];
        if (detailData.hasOwnProperty("SpFrmSql") && !_.isNil(detailData.SpFrmSql)) {
          const newSchema = data.obj.self.state.detailSchema.map(x => {
            if (x.field === "LMriez" || x.field === "TtMriez" || x.field === "SirMriez" || x.field === "PorMriez") {
              setProperties(detailData.SpFrmSql, x, "Mriez");
            } else if (x.field === "LDet" || x.field === "TtDet" || x.field === "SirDet" || x.field === "PorDet") {
              setProperties(detailData.SpFrmSql, x, "Det");
            } else if (x.field === "LHlad" || x.field === "TtHlad" || x.field === "SirHlad" || x.field === "PorHlad") {
              setProperties(detailData.SpFrmSql, x, "Hlad");
            } else if (x.field === "LZorad" || x.field === "TtZorad" || x.field === "SirZorad" || x.field === "PorZorad") {
              setProperties(detailData.SpFrmSql, x, "Zorad");
            }
            return x;
          });
          data.obj.self.state.detailSchema = newSchema;
        }
      }
      return state;

    case "ENTER_EDIT":
      return state;

    case "EXIT_EDIT":
      return state;

    case "ADD":
      return state;

    case "ITEM_CHANGE":
      console.debug(`[action=${action},field=${data.field},value=${data.value}]`);
      if (data.field === "LMriez" || data.field === "LDet" || data.field === "LHlad" || data.field === "LZorad") {
        modifyPropValue(data.dataItem, data);
      }
      return state;

    case "CHANGE":
      console.debug(`[action=${action},field=${data.field},value=${data.value},oldValue=${data.oldValue}]`);
      if (data.field === "LMriez" || data.field === "LDet" || data.field === "LHlad" || data.field === "LZorad") {
        const { detailData } = state[primaryField];
        modifyPropValue(detailData, data);
      }
      return state;

    case "UPDATE":
      return state;

    case "SELECT":
      return state;

    default:
      return state;
  }
}

export default reducer;
